<template>
    <div>
        <div class="Servic nrk">
            <p>设计理念</p>
            <span>方案优化、节省投资、环境友好、节省运行费用</span>
        </div>
        <Business-tow/>
        <div class="Servic nrk">
            <p>服务领域</p>
            <span> 医药、食品、保健品、化工、日用化工、石油化工、兽药、仓储物流、医疗器械、医疗建筑、科研建筑、<br/>动物实验室电子、工业与民用建筑。</span>
        </div>
        <div class="lsr">
            <div class="Servic nrk lisr">
                <p>核心理念</p>
                <span>我们的追求就是让顾客项目成功，顾客项目的成功就是我们的成功！</span>
            </div>
        </div>
        <div class="Servic nrk">
            <p>执行标准</p>
            <div class="lisn">
                <div class="lisn-ls">
                    <i>中国GMP标准</i>
                    <i>欧盟EEC GMP标准</i>
                    <i>美国FDA CGMP标准  </i>
                    <i>节能、减排、降耗、增效</i>
                </div>
                <img src="img/zs-1.jpg" >
            </div>
        </div>
    </div>
</template>

<script>
import BusinessTow from '@/components/pc/BusinessTow'
export default {
    components:{
        BusinessTow
    }
}
</script>

<style scoped>
    .lsr{
        background-image: linear-gradient(to right, #1b53b5 , #083da7);
        overflow: hidden;
        color: #fff;
        margin-top: 30px;
        padding-bottom: 30px;
    }
    .lisn{
        width: 800px;
        margin: 0 auto;
        margin-bottom: 40px;
        overflow: hidden;
    }
    .lisn-ls{
        float: left;
        width: 60%;
        text-align: left;
    }
    .lisn-ls i{
        display: block;
        line-height: 34px;
        font-size: 18px;
        margin-top: 30px;
    }
    .lisn img{
        float: right;
        width: 40%;
    }
</style>